import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import { STATUS_NEED_TO_PASS_KYC, STATUS_OK } from 'apps/auth/constants/Constants';
import { INCREASE_GA_LIMIT } from 'apps/auth/constants/UrlConstants';
import { getGaActivityDate } from 'apps/auth/helpers/utils';
import { useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { requestsIssueVirtualCard } from 'apps/auth/services/GaCardsService';

import { HAVE_BANK_ACCOUNT, KYC_IN_PROGRESS } from './LibreHistoryScreenConstants';
import LibreTermsPopup from './LibreTermsPopup';
import ActivityAmount from '../../components/ActivityAmount';
import ActivityIcon from '../../components/ActivityIcon';
import ActivityStatus from '../../components/ActivityStatus';
import ActivityTitle from '../../components/ActivityTitle';

const ActivityLibreDetails = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const messages = usePageMessages();
    const extra = useExtra();
    const { lang } = useLanguage();
    const popupRef = useRef(null);

    const showButton = ((!extra.card || extra.needInfoAboutBank) && mobileInfo.stsId === STATUS_OK) || mobileInfo.stsId === STATUS_NEED_TO_PASS_KYC;

    const getAmount = () => {
        if (mobileInfo.curRate) {
            return (
                <>
                    <ActivityAmount options={props.options} item={item} useArrow />
                    <ActivityAmount options={props.options} item={item} baseColor="primary" isFrom={false} />
                </>
            );
        }
        return <ActivityAmount options={props.options} item={item} baseColor="primary" />;
    };

    const getStatusText = () => {
        let statusText;
        if (mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = messages.chequeStatusCanceled;
        } else if (mobileInfo.stsId > STATUS_OK) {
            statusText = messages.chequeStatusError;
        } else if (showButton) {
            statusText = messages.chequeStatusAwaiting;
        } else if (mobileInfo.stsId === STATUS_OK) {
            statusText = messages.chequeStatusCompleted;
        } else if (mobileInfo.stsId < STATUS_OK) {
            statusText = messages.chequeStatusInProgress;
        }
        if (!statusText) {
            return mobileInfo.stsName;
        }
        return statusText;
    };

    const getStatusIcon = () => {
        if (mobileInfo.stsId > STATUS_OK) {
            return 'cross-rounded';
        } else if (showButton || mobileInfo.stsId < STATUS_OK) {
            return 'clock';
        } else if (mobileInfo.stsId === STATUS_OK) {
            return 'check';
        }
        return '';
    };

    const openLibreTermsPopup = () => {
        popupRef.current?.open(<LibreTermsPopup popupRef={popupRef} openLibreTermsPopup={openLibreTermsPopup} {...props} />);
    };

    const clickReceive = (e) => {
        e.preventDefault();

        if (extra.needToSignTerms) {
            openLibreTermsPopup();
            return;
        }

        if (mobileInfo.stsId === STATUS_NEED_TO_PASS_KYC) {
            if (extra.isWaitingStatus) {
                props.setScreen(KYC_IN_PROGRESS);
                return;
            }
            window.location.href = INCREASE_GA_LIMIT + '?action=receiveMoney';
            return;
        }

        if (extra.needInfoAboutBank) {
            props.setScreen(HAVE_BANK_ACCOUNT);
            return;
        }

        requestsIssueVirtualCard(extra?.pocket?.id, props.toggleSpinner, props.addExtras, props.setScreen);
    };

    const getActionButton = () => (
        <Panel isHoverable type="button" onClick={clickReceive} negativeMargin>
            <DiskBadgeWrapper>
                <DiskBadge variant="primary" iconName="check" />
            </DiskBadgeWrapper>
            <Text color="primary">{messages.receiveButton}</Text>
        </Panel>
    );

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} flagName="paysend" />
            </Row>
            <ActivityTitle message={item.extra.sender_first_name + ' ' + item.extra.sender_last_name} color={textColor} />
            <Row indent="adaptive-24-32">
                {getAmount()}
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus isShowStatus status={mobileInfo.stsId} text={getStatusText()} isUseExternalIconName externalGetIconName={getStatusIcon} />
            </Row>
            {mobileInfo.errorMessage && <div>{mobileInfo.errorMessage}</div>}
            {showButton && (
                <>
                    <Separator marginBottom="16px" />
                    {getActionButton()}
                </>
            )}
            <Separator marginBottom="16px" />
            <TableContainer>
                <TableRow title={messages.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, lang)}
                </TableRow>
            </TableContainer>
            <PopupNew getPopupComponent={(component) => component} ref={popupRef} />
        </>
    );
};

export default connect(null, {
    toggleSpinner,
    addExtras,
})(ActivityLibreDetails);
